import './tag.sass';

export { default } from './tag';
